import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { datesDefault } from "../components/AssetManagement/Overview/Trends/helpers/funcs/datesDefault";
const DEFAULT_FILTERS = {
  trafficSource: null,
  country: null,
  campaign: null,
  adGroup: null,
  keyword: null,
};
interface Option {
  label: string;
  value: string;
}
const initialState = {
  trendsDashboardExecuteQueriesData: [],
  selectedSharedUid: [],
  fetchBy: "site",
  dataSet:
    new URLSearchParams(window.location.search).get("dataSet") || "click",
  selectedStartDate: dayjs().startOf("month"),
  selectedEndDate: dayjs().endOf("month"),
  showTrendsTabs: false,
  show: false,
  display: false,
  defaultWebsiteUid: null,
  defaultDimension: null,
  selectedTimeUnit: datesDefault[0],
  selectedTimeUnitCac: datesDefault[0],
  selectedTimeUnitImp: datesDefault[0],
  selectedTimeUnitCpc: datesDefault[0],
  selectedTimeUnitCi: datesDefault[0],
  selectedTimeUnitCo: datesDefault[0],
  selectedTimeUnitCoi: datesDefault[0],
  selectedTimeUnitEpc: datesDefault[0],
  selectedTimeUnitFr: datesDefault[0],
  selectedTimeUnitCpa: datesDefault[0],
  selectedTimeUnitCpapv: datesDefault[0],
  selectedTimeUnitAcpa: datesDefault[0],
  selectedTimeUnitCr: datesDefault[0],
  selectedTimeUnitFtd: datesDefault[0],
  selectedTimeUnitGftdqftd: datesDefault[0],
  selectedTimeUnitPftd: datesDefault[0],
  selectedTimeUnitPv: datesDefault[0],
  selectedTimeUnitNrpf: datesDefault[0],
  selectedTimeUnitP: datesDefault[0],
  selectedTimeUnitS: datesDefault[0],
  selectedTimeUnitTi: datesDefault[0],
  selectedTimeUnitRs: datesDefault[0],
  selectedTimeUnitRspv: datesDefault[0],
  selectedTimeUnitArspd: datesDefault[0],
  organizationOptions: [],
  organizationDimensions: [],
  trafficSourceData: [],
  geoData: [],
  filterBizLayerQueryDataMap: {},
  trendsFilters: [],
  isLoadingFilter: false,
  activityNotesDataGlobal: [],
  loadingNotes: false,
  cacDataRedux: [],
  impDataRedux: [],
  cpcDataRedux: [],
  ciDataRedux: [],
  coDataRedux: [],
  coiDataRedux: [],
  epcDataRedux: [],
  frDataRedux: [],
  cpaDataRedux: [],
  cpapvDataRedux: [],
  acpaDataRedux: [],
  crDataRedux: [],
  ftdDataRedux: [],
  gftdqftdDataRedux: [],
  pftdDataRedux: [],
  pvDataRedux: [],
  nrpfDataRedux: [],
  pDataRedux: [],
  sDataRedux: [],
  tiDataRedux: [],
  rsDataRedux: [],
  rspvDataRedux: [],
  arspdDataRedux: [],

  //Trends Breakdown Slice
  countryDataTrendsBreakdown: [],
  trafficSourceDataTrendsBreakdown: [],
  campaignDataTrendsBreakdown: [],
  adGroupDataTrendsBreakdown: [],
  keywordMatchTypeDataTrendsBreakdown: [],
  brandsDataTrendsBreakdown: [],
  groupBy: null,
  trafficSourceBD: null,
  inCampaignBD: null,
  selectedKeyword: null,
  selectedMatchTypeFilterBD: null,
  selectedCampaignFilterBD: null,
  selectedAdGroupFilterBD: null,
  selectedTrafficSourceFilterBD: null,
  selectedSearchBrand: null,
  isLoadingBDAds: false,
  isChildrenAPILoadingBDAds: false,
  loadingTrafficSourceFilters: false,

  //Trends Mobile Stateds
  trendsMobileData: [],
  loadingTrendsMobData: false,
  trafficSourceDataMobile: [],
  geoDataMobile: [],
  loadingGeoTrafficData: false,
  filterDataByIdMobileMap: {},
  mobileFilters: DEFAULT_FILTERS,
  activityNotesDataTrendsMobile: [],
  notesLabelFilter: null,
  cacMobileDataRedux: [],
  cacMobileLoading: false,
  frMobileDataRedux: [],
  frMobileLoading: false,
  impsMobileDataRedux: [],
  impsMobileLoading: false,
  cpcMobileDataRedux: [],
  cpcMobileLoading: false,
  ciMobileDataRedux: [],
  ciMobileLoading: false,
  coMobileDataRedux: [],
  coMobileLoading: false,
  coiMobileDataRedux: [],
  coiMobileLoading: false,
  epcMobileDataRedux: [],
  epcMobileLoading: false,
  cpaiMobileDataRedux: [],
  cpaiMobileLoading: false,
  cpapvMobileDataRedux: [],
  cpapvMobileLoading: false,
  acpaiMobileDataRedux: [],
  acpaiMobileLoading: false,
  crMobileDataRedux: [],
  crMobileLoading: false,
  ftdMobileDataRedux: [],
  ftdMobileLoading: false,
  gftdqftdMobileDataRedux: [],
  gftdqftdMobileLoading: false,
  pftdMobileDataRedux: [],
  pftdMobileLoading: false,
  pvMobileDataRedux: [],
  pvMobileLoading: false,
  nrpfMobileDataRedux: [],
  nrpfMobileLoading: false,
  pMobileDataRedux: [],
  pMobileLoading: false,
  sMobileDataRedux: [],
  sMobileLoading: false,
  tiMobileDataRedux: [],
  tiMobileLoading: false,
  rsMobileDataRedux: [],
  rsMobileLoading: false,
  rspvMobileDataRedux: [],
  rspvMobileLoading: false,
  arspdMobileDataRedux: [],
  arspdMobileLoading: false,
};

const trendsSlice = createSlice({
  name: "trends",
  initialState,
  reducers: {
    setTrendsDashboardExecuteQueriesData: (state, action) => {
      state.trendsDashboardExecuteQueriesData = action.payload;
    },
    setFetchBy: (state, action) => {
      state.fetchBy = action.payload;
    },
    setDataSet: (state, action) => {
      state.dataSet = action.payload;
    },
    setSelectedStartDate: (state, action) => {
      state.selectedStartDate = action.payload;
    },
    setSelectedEndDate: (state, action) => {
      state.selectedEndDate = action.payload;
    },
    setShowTrendsTabs: (state, action) => {
      state.showTrendsTabs = action.payload;
    },
    setShow: (state, action) => {
      state.show = action.payload;
    },
    setDisplay: (state, action) => {
      state.display = action.payload;
    },
    setSelectedTimeUnit: (state, action) => {
      state.selectedTimeUnit = action.payload;
    },
    setSelectedTimeUnitCac: (state, action) => {
      state.selectedTimeUnitCac = action.payload;
    },
    setSelectedTimeUnitImp: (state, action) => {
      state.selectedTimeUnitImp = action.payload;
    },
    setSelectedTimeUnitCpc: (state, action) => {
      state.selectedTimeUnitCpc = action.payload;
    },
    setSelectedTimeUnitCi: (state, action) => {
      state.selectedTimeUnitCi = action.payload;
    },
    setSelectedTimeUnitCo: (state, action) => {
      state.selectedTimeUnitCo = action.payload;
    },
    setSelectedTimeUnitCoi: (state, action) => {
      state.selectedTimeUnitCoi = action.payload;
    },
    setSelectedTimeUnitEpc: (state, action) => {
      state.selectedTimeUnitEpc = action.payload;
    },
    setSelectedTimeUnitFr: (state, action) => {
      state.selectedTimeUnitFr = action.payload;
    },
    setSelectedTimeUnitCpa: (state, action) => {
      state.selectedTimeUnitCpa = action.payload;
    },
    setSelectedTimeUnitCpapv: (state, action) => {
      state.selectedTimeUnitCpapv = action.payload;
    },
    setSelectedTimeUnitAcpa: (state, action) => {
      state.selectedTimeUnitAcpa = action.payload;
    },
    setSelectedTimeUnitCr: (state, action) => {
      state.selectedTimeUnitCr = action.payload;
    },
    setSelectedTimeUnitFtd: (state, action) => {
      state.selectedTimeUnitFtd = action.payload;
    },
    setSelectedTimeUnitGftdqftd: (state, action) => {
      state.selectedTimeUnitGftdqftd = action.payload;
    },
    setSelectedTimeUnitPftd: (state, action) => {
      state.selectedTimeUnitPftd = action.payload;
    },
    setSelectedTimeUnitPv: (state, action) => {
      state.selectedTimeUnitPv = action.payload;
    },
    setSelectedTimeUnitNrpf: (state, action) => {
      state.selectedTimeUnitNrpf = action.payload;
    },
    setSelectedTimeUnitP: (state, action) => {
      state.selectedTimeUnitP = action.payload;
    },
    setSelectedTimeUnitS: (state, action) => {
      state.selectedTimeUnitS = action.payload;
    },
    setSelectedTimeUnitTi: (state, action) => {
      state.selectedTimeUnitTi = action.payload;
    },
    setSelectedTimeUnitRs: (state, action) => {
      state.selectedTimeUnitRs = action.payload;
    },
    setSelectedTimeUnitRspv: (state, action) => {
      state.selectedTimeUnitRspv = action.payload;
    },
    setSelectedTimeUnitArspd: (state, action) => {
      state.selectedTimeUnitArspd = action.payload;
    },
    setOrganizationOptions: (state, action) => {
      state.organizationOptions = action.payload;
    },
    setOrganizationDimensions: (state, action) => {
      state.organizationDimensions = action.payload;
    },

    setTrafficSourceData: (state, action) => {
      state.trafficSourceData = action.payload;
    },
    setGeoData: (state, action) => {
      state.geoData = action.payload;
    },
    setFilterBizLayerQueryDataById: (state: any, action) => {
      const { key, data } = action.payload;
      state.filterBizLayerQueryDataMap[key] = data;
    },
    clearFilterBizLayerQueryDataMap: (state) => {
      state.filterBizLayerQueryDataMap = {};
    },
    setTrendsFilter(state: any, action) {
      // Replace if key exists, else push
      const existingIndex = state.trendsFilters?.findIndex(
        (item: any) => item.key === action.payload.key,
      );
      if (existingIndex >= 0) {
        state.trendsFilters[existingIndex] = action.payload;
      } else {
        state.trendsFilters.push(action.payload);
      }
    },
    clearTrendsFilters(state) {
      state.trendsFilters = [];
    },
    setSelectedSharedUid(state, action) {
      state.selectedSharedUid = action.payload;
    },

    setIsLoadingFilter(state, action) {
      state.isLoadingFilter = action.payload;
    },
    setActivityNotesDataGlobal(state, action) {
      state.activityNotesDataGlobal = action.payload;
    },

    setDefaultWebsiteUid(state, action) {
      state.defaultWebsiteUid = action.payload;
    },
    setDefaultDimension(state, action) {
      state.defaultDimension = action.payload;
    },
    setLoadingNotes(state, action) {
      state.loadingNotes = action.payload;
    },
    setCacDataRedux(state, action) {
      state.cacDataRedux = action.payload;
    },
    setImpDataRedux(state, action) {
      state.impDataRedux = action.payload;
    },
    setCpcDataRedux(state, action) {
      state.cpcDataRedux = action.payload;
    },
    setCiDataRedux(state, action) {
      state.ciDataRedux = action.payload;
    },
    setCoDataRedux(state, action) {
      state.coDataRedux = action.payload;
    },
    setCoiDataRedux(state, action) {
      state.coiDataRedux = action.payload;
    },
    setEpcDataRedux(state, action) {
      state.epcDataRedux = action.payload;
    },
    setFrDataRedux(state, action) {
      state.frDataRedux = action.payload;
    },
    setCpaDataRedux(state, action) {
      state.cpaDataRedux = action.payload;
    },
    setCpapvDataRedux(state, action) {
      state.cpapvDataRedux = action.payload;
    },
    setAcpaDataRedux(state, action) {
      state.acpaDataRedux = action.payload;
    },
    setCrDataRedux(state, action) {
      state.crDataRedux = action.payload;
    },
    setFtdDataRedux(state, action) {
      state.ftdDataRedux = action.payload;
    },
    setGftdqftdDataRedux(state, action) {
      state.gftdqftdDataRedux = action.payload;
    },
    setPftdDataRedux(state, action) {
      state.pftdDataRedux = action.payload;
    },
    setPvDataRedux(state, action) {
      state.pvDataRedux = action.payload;
    },
    setNrpfDataRedux(state, action) {
      state.nrpfDataRedux = action.payload;
    },
    setPDataRedux(state, action) {
      state.pDataRedux = action.payload;
    },
    setSDataRedux(state, action) {
      state.sDataRedux = action.payload;
    },
    setTiDataRedux(state, action) {
      state.tiDataRedux = action.payload;
    },
    setRsDataRedux(state, action) {
      state.rsDataRedux = action.payload;
    },
    setRspvDataRedux(state, action) {
      state.rspvDataRedux = action.payload;
    },
    setArspdDataRedux(state, action) {
      state.arspdDataRedux = action.payload;
    },
    clearAllTimeUnits: (state) => {
      state.selectedTimeUnit = datesDefault[0];
      state.selectedTimeUnitCac = datesDefault[0];
      state.selectedTimeUnitImp = datesDefault[0];
      state.selectedTimeUnitCpc = datesDefault[0];
      state.selectedTimeUnitCi = datesDefault[0];
      state.selectedTimeUnitCo = datesDefault[0];
      state.selectedTimeUnitCoi = datesDefault[0];
      state.selectedTimeUnitEpc = datesDefault[0];
      state.selectedTimeUnitFr = datesDefault[0];
      state.selectedTimeUnitCpa = datesDefault[0];
      state.selectedTimeUnitCpapv = datesDefault[0];
      state.selectedTimeUnitAcpa = datesDefault[0];
      state.selectedTimeUnitCr = datesDefault[0];
      state.selectedTimeUnitFtd = datesDefault[0];
      state.selectedTimeUnitGftdqftd = datesDefault[0];
      state.selectedTimeUnitPftd = datesDefault[0];
      state.selectedTimeUnitPv = datesDefault[0];
      state.selectedTimeUnitNrpf = datesDefault[0];
      state.selectedTimeUnitP = datesDefault[0];
      state.selectedTimeUnitS = datesDefault[0];
      state.selectedTimeUnitTi = datesDefault[0];
      state.selectedTimeUnitRs = datesDefault[0];
      state.selectedTimeUnitRspv = datesDefault[0];
      state.selectedTimeUnitArspd = datesDefault[0];
    },
    clearAllTimeUnitsData: (state) => {
      state.cacDataRedux = [];
      state.impDataRedux = [];
      state.cpcDataRedux = [];
      state.ciDataRedux = [];
      state.coDataRedux = [];
      state.coiDataRedux = [];
      state.epcDataRedux = [];
      state.frDataRedux = [];
      state.cpaDataRedux = [];
      state.cpapvDataRedux = [];
      state.acpaDataRedux = [];
      state.crDataRedux = [];
      state.ftdDataRedux = [];
      state.gftdqftdDataRedux = [];
      state.pftdDataRedux = [];
      state.pvDataRedux = [];
      state.nrpfDataRedux = [];
      state.pDataRedux = [];
      state.sDataRedux = [];
      state.tiDataRedux = [];
      state.rsDataRedux = [];
      state.rspvDataRedux = [];
      state.arspdDataRedux = [];
    },
    setCountryDataTrendsBreakdown: (state, action) => {
      state.countryDataTrendsBreakdown = action.payload;
    },
    setTrafficSourceDataTrendsBreakdown: (state, action) => {
      state.trafficSourceDataTrendsBreakdown = action.payload;
    },
    setCampaignDataTrendsBreakdown: (state, action) => {
      state.campaignDataTrendsBreakdown = action.payload;
    },
    setAdGroupDataTrendsBreakdown: (state, action) => {
      state.adGroupDataTrendsBreakdown = action.payload;
    },
    setKeywordMatchTypeDataTrendsBreakdown: (state, action) => {
      state.keywordMatchTypeDataTrendsBreakdown = action.payload;
    },

    setBrandsDataTrendsBreakdown: (state, action) => {
      state.brandsDataTrendsBreakdown = action.payload;
    },
    setGroupBy: (state, action) => {
      state.groupBy = action.payload;
    },
    setTrafficSourceBD: (state, action) => {
      state.trafficSourceBD = action.payload;
    },
    setInCampaignBD: (state, action) => {
      state.inCampaignBD = action.payload;
    },
    setSelectedKeyword: (state, action) => {
      state.selectedKeyword = action.payload;
    },

    setSelectedMatchTypeFilterBD: (state, action) => {
      state.selectedMatchTypeFilterBD = action.payload;
    },
    setSelectedCampaignFilterBD: (state, action) => {
      state.selectedCampaignFilterBD = action.payload;
    },
    setSelectedAdGroupFilterBD: (state, action) => {
      state.selectedAdGroupFilterBD = action.payload;
    },
    setSelectedTrafficSourceFilterBD: (state, action) => {
      state.selectedTrafficSourceFilterBD = action.payload;
    },
    setSelectedSearchBrand: (state, action) => {
      state.selectedSearchBrand = action.payload;
    },
    setIsLoadingBDAds: (state, action) => {
      state.isLoadingBDAds = action.payload;
    },
    setIsChildrenAPILoadingBDAds: (state, action) => {
      state.isChildrenAPILoadingBDAds = action.payload;
    },
    // Add this to your trendsSlice reducers
    removeTrendsFilter: (state, action) => {
      state.trendsFilters = state.trendsFilters.filter(
        (filter: any) => filter.key !== action.payload,
      );
    },
    setLoadingTrafficSourceFilters: (state, action) => {
      state.loadingTrafficSourceFilters = action.payload;
    },
    setTrendsMobileData: (state, action) => {
      state.trendsMobileData = action.payload;
    },
    setLoadingTrendsMobData: (state, action) => {
      state.loadingTrendsMobData = action.payload;
    },
    setTrafficSourceDataMobile: (state, action) => {
      state.trafficSourceDataMobile = action.payload;
    },
    setGeoDataMobile: (state, action) => {
      state.geoDataMobile = action.payload;
    },
    setLoadingGeoTrafficData: (state, action) => {
      state.loadingGeoTrafficData = action.payload;
    },
    setFilterDataByIdMobile: (state: any, action) => {
      const { key, data } = action.payload;
      state.filterDataByIdMobileMap[key] = data;
    },
    clearFilterMobileDataMap: (state) => {
      state.filterDataByIdMobileMap = {};
    },
    setMobileFilters: (state, action) => {
      state.mobileFilters = action.payload;
    },

    updateMobileFilter: (
      state: any,
      action: PayloadAction<{ key: string; value: Option | null }>,
    ) => {
      const { key, value } = action.payload;
      state.mobileFilters[key] = value;
    },
    setMobileFiltersPartial: (state, action) => {
      state.mobileFilters = {
        ...state.mobileFilters,
        ...action.payload,
      };
    },

    resetMobileFilters: (state) => {
      state.mobileFilters = DEFAULT_FILTERS;
    },
    setActivityNotesDataTrendsMobile: (state, action) => {
      state.activityNotesDataTrendsMobile = action.payload;
    },
    setNotesLabelFilter: (state, action) => {
      state.notesLabelFilter = action.payload;
    },
    setCacMobileDataRedux: (state, action) => {
      state.cacMobileDataRedux = action.payload;
    },
    setCacMobileLoading: (state, action) => {
      state.cacMobileLoading = action.payload;
    },
    setFrMobileDataRedux: (state, action) => {
      state.frMobileDataRedux = action.payload;
    },
    setFrMobileLoading: (state, action) => {
      state.frMobileLoading = action.payload;
    },
    setImpsMobileDataRedux: (state, action) => {
      state.impsMobileDataRedux = action.payload;
    },
    setImpsMobileLoading: (state, action) => {
      state.impsMobileLoading = action.payload;
    },
    setCpcMobileDataRedux: (state, action) => {
      state.cpcMobileDataRedux = action.payload;
    },
    setCpcMobileLoading: (state, action) => {
      state.cpcMobileLoading = action.payload;
    },
    setCiMobileDataRedux: (state, action) => {
      state.ciMobileDataRedux = action.payload;
    },
    setCiMobileLoading: (state, action) => {
      state.ciMobileLoading = action.payload;
    },
    setCoMobileDataRedux: (state, action) => {
      state.coMobileDataRedux = action.payload;
    },
    setCoMobileLoading: (state, action) => {
      state.coMobileLoading = action.payload;
    },
    setCoiMobileDataRedux: (state, action) => {
      state.coiMobileDataRedux = action.payload;
    },
    setCoiMobileLoading: (state, action) => {
      state.coiMobileLoading = action.payload;
    },
    setEpcMobileDataRedux: (state, action) => {
      state.epcMobileDataRedux = action.payload;
    },
    setEpcMobileLoading: (state, action) => {
      state.epcMobileLoading = action.payload;
    },
    setCpaiMobileDataRedux: (state, action) => {
      state.cpaiMobileDataRedux = action.payload;
    },
    setCpaiMobileLoading: (state, action) => {
      state.cpaiMobileLoading = action.payload;
    },
    setCpapvMobileDataRedux: (state, action) => {
      state.cpapvMobileDataRedux = action.payload;
    },
    setCpapvMobileLoading: (state, action) => {
      state.cpapvMobileLoading = action.payload;
    },
    setAcpaiMobileDataRedux: (state, action) => {
      state.acpaiMobileDataRedux = action.payload;
    },
    setAcpaiMobileLoading: (state, action) => {
      state.acpaiMobileLoading = action.payload;
    },
    setCrMobileDataRedux: (state, action) => {
      state.crMobileDataRedux = action.payload;
    },
    setCrMobileLoading: (state, action) => {
      state.crMobileLoading = action.payload;
    },
    setFtdMobileDataRedux: (state, action) => {
      state.ftdMobileDataRedux = action.payload;
    },
    setFtdMobileLoading: (state, action) => {
      state.ftdMobileLoading = action.payload;
    },
    setGftdqftdMobileDataRedux: (state, action) => {
      state.gftdqftdMobileDataRedux = action.payload;
    },
    setGftdqftdMobileLoading: (state, action) => {
      state.gftdqftdMobileLoading = action.payload;
    },
    setPftdMobileDataRedux: (state, action) => {
      state.pftdMobileDataRedux = action.payload;
    },
    setPftdMobileLoading: (state, action) => {
      state.pftdMobileLoading = action.payload;
    },
    setPvMobileDataRedux: (state, action) => {
      state.pvMobileDataRedux = action.payload;
    },
    setPvMobileLoading: (state, action) => {
      state.pvMobileLoading = action.payload;
    },
    setNrpfMobileDataRedux: (state, action) => {
      state.nrpfMobileDataRedux = action.payload;
    },
    setNrpfMobileLoading: (state, action) => {
      state.nrpfMobileLoading = action.payload;
    },
    setPMobileDataRedux: (state, action) => {
      state.pMobileDataRedux = action.payload;
    },
    setPMobileLoading: (state, action) => {
      state.pMobileLoading = action.payload;
    },
    setSMobileDataRedux: (state, action) => {
      state.sMobileDataRedux = action.payload;
    },
    setSMobileLoading: (state, action) => {
      state.sMobileLoading = action.payload;
    },
    setTiMobileDataRedux: (state, action) => {
      state.tiMobileDataRedux = action.payload;
    },
    setTiMobileLoading: (state, action) => {
      state.tiMobileLoading = action.payload;
    },
    setRsMobileDataRedux: (state, action) => {
      state.rsMobileDataRedux = action.payload;
    },
    setRsMobileLoading: (state, action) => {
      state.rsMobileLoading = action.payload;
    },
    setRspvMobileDataRedux: (state, action) => {
      state.rspvMobileDataRedux = action.payload;
    },
    setRspvMobileLoading: (state, action) => {
      state.rspvMobileLoading = action.payload;
    },
    setArspdMobileDataRedux: (state, action) => {
      state.arspdMobileDataRedux = action.payload;
    },
    setArspdMobileLoading: (state, action) => {
      state.arspdMobileLoading = action.payload;
    },
  },
});

export const {
  setTrendsDashboardExecuteQueriesData,
  setFetchBy,
  setDataSet,
  setSelectedStartDate,
  setSelectedEndDate,
  setShowTrendsTabs,
  setShow,
  setDisplay,
  setSelectedTimeUnit,
  setSelectedTimeUnitCac,
  setOrganizationOptions,
  setOrganizationDimensions,
  setTrafficSourceData,
  setGeoData,
  setFilterBizLayerQueryDataById,
  clearFilterBizLayerQueryDataMap,
  setTrendsFilter,
  clearTrendsFilters,
  setSelectedSharedUid,
  setIsLoadingFilter,
  setActivityNotesDataGlobal,
  setLoadingNotes,
  setCacDataRedux,
  clearAllTimeUnits,
  clearAllTimeUnitsData,
  setImpDataRedux,
  setSelectedTimeUnitImp,
  setCpcDataRedux,
  setSelectedTimeUnitCpc,
  setCiDataRedux,
  setSelectedTimeUnitCi,
  setCoDataRedux,
  setSelectedTimeUnitCo,
  setCoiDataRedux,
  setSelectedTimeUnitCoi,
  setEpcDataRedux,
  setSelectedTimeUnitEpc,
  setFrDataRedux,
  setSelectedTimeUnitFr,
  setCpaDataRedux,
  setSelectedTimeUnitCpa,
  setCpapvDataRedux,
  setSelectedTimeUnitCpapv,
  setAcpaDataRedux,
  setSelectedTimeUnitAcpa,
  setCrDataRedux,
  setSelectedTimeUnitCr,
  setFtdDataRedux,
  setSelectedTimeUnitFtd,
  setGftdqftdDataRedux,
  setSelectedTimeUnitGftdqftd,
  setPftdDataRedux,
  setSelectedTimeUnitPftd,
  setPvDataRedux,
  setSelectedTimeUnitPv,
  setNrpfDataRedux,
  setSelectedTimeUnitNrpf,
  setPDataRedux,
  setSelectedTimeUnitP,
  setSDataRedux,
  setSelectedTimeUnitS,
  setTiDataRedux,
  setSelectedTimeUnitTi,
  setRsDataRedux,
  setSelectedTimeUnitRs,
  setRspvDataRedux,
  setSelectedTimeUnitRspv,
  setArspdDataRedux,
  setSelectedTimeUnitArspd,
  setCountryDataTrendsBreakdown,
  setTrafficSourceDataTrendsBreakdown,
  setCampaignDataTrendsBreakdown,
  setAdGroupDataTrendsBreakdown,
  setKeywordMatchTypeDataTrendsBreakdown,
  setBrandsDataTrendsBreakdown,
  setGroupBy,
  setTrafficSourceBD,
  setInCampaignBD,
  setSelectedKeyword,
  setSelectedMatchTypeFilterBD,
  setSelectedCampaignFilterBD,
  setSelectedAdGroupFilterBD,
  setSelectedTrafficSourceFilterBD,
  setSelectedSearchBrand,
  setIsLoadingBDAds,
  setIsChildrenAPILoadingBDAds,
  removeTrendsFilter,
  setLoadingTrafficSourceFilters,
  setDefaultWebsiteUid,
  setDefaultDimension,
  setTrendsMobileData,
  setLoadingTrendsMobData,
  setTrafficSourceDataMobile,
  setGeoDataMobile,
  setLoadingGeoTrafficData,
  setFilterDataByIdMobile,
  clearFilterMobileDataMap,
  setMobileFilters,
  updateMobileFilter,
  setMobileFiltersPartial,
  resetMobileFilters,
  setActivityNotesDataTrendsMobile,
  setNotesLabelFilter,
  setCacMobileDataRedux,
  setCacMobileLoading,
  setFrMobileDataRedux,
  setFrMobileLoading,
  setImpsMobileDataRedux,
  setImpsMobileLoading,
  setCpcMobileDataRedux,
  setCpcMobileLoading,
  setCiMobileDataRedux,
  setCiMobileLoading,
  setCoMobileDataRedux,
  setCoMobileLoading,
  setCoiMobileDataRedux,
  setCoiMobileLoading,
  setEpcMobileDataRedux,
  setEpcMobileLoading,
  setCpaiMobileDataRedux,
  setCpaiMobileLoading,
  setCpapvMobileDataRedux,
  setCpapvMobileLoading,
  setAcpaiMobileDataRedux,
  setAcpaiMobileLoading,
  setCrMobileDataRedux,
  setCrMobileLoading,
  setFtdMobileDataRedux,
  setFtdMobileLoading,
  setGftdqftdMobileDataRedux,
  setGftdqftdMobileLoading,
  setPftdMobileDataRedux,
  setPftdMobileLoading,
  setPvMobileDataRedux,
  setPvMobileLoading,
  setNrpfMobileDataRedux,
  setNrpfMobileLoading,
  setPMobileDataRedux,
  setPMobileLoading,
  setSMobileDataRedux,
  setSMobileLoading,
  setTiMobileDataRedux,
  setTiMobileLoading,
  setRsMobileDataRedux,
  setRsMobileLoading,
  setRspvMobileDataRedux,
  setRspvMobileLoading,
  setArspdMobileDataRedux,
  setArspdMobileLoading,
} = trendsSlice.actions;
export default trendsSlice.reducer;
